module.exports = __webpack_public_path__ + "img/y2.5417d4ea.jpg";